export interface NavItemProps {
  id: string;
  messageId: string;
  title: string;
  icon?: string;
  url?: string;
  type?: string;
  count?: number;
  color?: string;
  children?: NavItemProps[] | NavItemProps;
}

const routesConfig: NavItemProps[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    messageId: 'sidebar.dashboard',
    type: 'item',
    url: '/dashboard',
    icon: 'home',
  },
  {
    id: 'token',
    title: 'Token',
    messageId: 'sidebar.token',
    type: 'group',
    children: [
      {
        id: 'pausing',
        title: 'Token Pause',
        messageId: 'sidebar.token.pause',
        type: 'item',
        url: '/token/pause',
      },
      {
        id: 'supply',
        title: 'Token Supply',
        messageId: 'sidebar.token.supply',
        type: 'item',
        url: '/token/supply',
      },
    ],
  },
  {
    id: 'goldReserve',
    title: 'Gold Reserve',
    messageId: 'sidebar.gold',
    type: 'item',
    url: '/goldReserve',
  },
  {
    id: 'price',
    title: 'Price',
    messageId: 'sidebar.price',
    type: 'item',
    url: '/price',
  },
  {
    id: 'feeManagement',
    title: 'Fee Management',
    messageId: 'sidebar.feeManagement',
    type: 'item',
    url: '/feeManagement',
  },
  {
    id: 'fees',
    title: 'Fees',
    messageId: 'sidebar.fees',
    type: 'item',
    url: '/fees',
  },
  {
    id: 'admin',
    title: 'Admin',
    messageId: 'sidebar.admin',
    type: 'item',
    url: '/admins',
  },
  {
    id: 'special-wallets',
    title: 'Special wallets',
    messageId: 'sidebar.specialWallets',
    type: 'item',
    url: '/specialWallet',
  },
];
export default routesConfig;